import { render } from "./Anmeldung.vue?vue&type=template&id=226c09cc&lang=pug"
import script from "./Anmeldung.vue?vue&type=script&lang=js"
export * from "./Anmeldung.vue?vue&type=script&lang=js"

import "./Anmeldung.vue?vue&type=style&index=0&id=226c09cc&lang=scss"

import exportComponent from "/schmetterlinge/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__